module.exports = __webpack_public_path__ + "img/fd-loading.e753070a.png";